import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { tr } from "@util/tr";

@Component({
  selector: "ws-actions",
  templateUrl: "./ws-actions.component.html",
  styleUrls: ["./ws-actions.component.scss"],
})
export class WsActionsComponent {
  // Options for the selector, can be objects or strings
  @Input() options: Array<{
    id: string;
    name: string;
    icon: string | undefined;
    /** Emulates mockup danger rows (e.g. storno) — red label + icon */
    danger?: boolean;
    /** When true, menu item is not clickable (e.g. force-create receipt already exists). */
    disabled?: boolean;
    /** Shown on disabled items (native title tooltip). */
    tooltip?: string;
  }> | null = [];

  @Input() callToActionType: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'warning'| 'info' | 'success' | undefined ;
  @Input() text: string | undefined;
  @Input() icon: string = "more_vert";
  @Input() disabled: boolean = false;

  // For the selected item
  @Output() clickOnAction: EventEmitter<{ id: string; name: string }> =
    new EventEmitter<{ id: string; name: string }>();

  // Formatter function to display the name of the selected item
  @Input() formatter: (item: any) => string = (item) =>
    typeof item === "string" ? item : tr(item?.name) || tr("None");

  @Input() showActionIcon: boolean = true;

  // Tooltip for the button
  @Input() tooltip: string = tr("Actions");
  @Input() disabledActions: boolean = false;
  /** When true, button click emits clickOnAction immediately without opening the menu. */
  @Input() directClick: boolean = false;
  menuOpen: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {}

  /** N-7: stable mat-menu item identity while the panel is open. */
  trackByOptionId = (_: number, option: { id?: string; name?: string }): string =>
    option?.id != null ? String(option.id) : String(option?.name ?? _);

  // Check if action should prevent menu closing
  shouldPreventClose(option: { id: string; name: string }): boolean {
    return this.disabledActions && (option.id === 'send_now' || option.id === 'send_programmed');
  }

  isOptionDisabled(option: { id: string; name: string; disabled?: boolean }): boolean {
    return !!option.disabled;
  }

  // Handle click with prevention of menu closing for disabled actions
  onClickActionWithPreventClose(option: { id: string; name: string; disabled?: boolean }, event: Event): void {
    if (this.isOptionDisabled(option)) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    if (this.shouldPreventClose(option)) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.clickOnAction.emit(option);
    // Only close menu if this is not a disabled red send action
    if (!this.shouldPreventClose(option)) {
      this.onMenuClosed();
    }
  }

  // Emit changes when an item is selected
  onClickOnActionInt(option: { id: string; name: string }): void {
    this.clickOnAction.emit(option);
    this.onMenuClosed();
  }

  // Set the menu open state
  setMenuOpen(state: boolean): void {
    this.menuOpen = state;
  }

  // Called when the menu is opened
  onMenuOpened(event : MouseEvent): void {
    if(event){
      event.stopPropagation();
      event.preventDefault();
    }
    this.menuOpen = true;
  }

  // Called when the menu is closed
  onMenuClosed(): void {
    this.menuOpen = false;
  }

  onDirectClick(event: MouseEvent): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const option = this.options?.[0] ?? { id: "direct", name: "", icon: undefined };
    this.clickOnAction.emit(option);
  }

}
